// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3PRKU","title":"AfterFrontImage_title__1Hsrv"};